import { render, staticRenderFns } from "./crateForecast.vue?vue&type=template&id=1c60a642&scoped=true"
import script from "./crateForecast.vue?vue&type=script&lang=js"
export * from "./crateForecast.vue?vue&type=script&lang=js"
import style0 from "./crateForecast.vue?vue&type=style&index=0&id=1c60a642&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c60a642",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c60a642')) {
      api.createRecord('1c60a642', component.options)
    } else {
      api.reload('1c60a642', component.options)
    }
    module.hot.accept("./crateForecast.vue?vue&type=template&id=1c60a642&scoped=true", function () {
      api.rerender('1c60a642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Production/crateForecast.vue"
export default component.exports